import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

const WebsiteForm = ({ 
  open, 
  onClose, 
  formData, 
  setFormData, 
  onSubmit, 
  title, 
  submitText 
}) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleTagsChange = (e) => {
    const tagsString = e.target.value;
    
    // Store the raw input string in the form data
    setFormData(prev => ({ 
      ...prev, 
      tempTagsString: tagsString 
    }));

    // Process the tags array separately (only for actual data storage)
    const tagsArray = tagsString.split(',')
      .map(tag => tag.trim())
      .filter(tag => tag !== '');
      
    setFormData(prev => ({ 
      ...prev, 
      tags: tagsArray
    }));
  };

  const handleExternalSiteChange = (e) => {
    setFormData(prev => ({ 
      ...prev, 
      externalSite: e.target.value === 'true' 
    }));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              name="name"
              label="Website Name"
              value={formData.name}
              onChange={handleInputChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="description"
              label="Description"
              value={formData.description}
              onChange={handleInputChange}
              fullWidth
              multiline
              rows={3}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="url"
              label="URL"
              value={formData.url}
              onChange={handleInputChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="logo"
              label="Logo URL"
              value={formData.logo}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                name="status"
                value={formData.status}
                onChange={handleInputChange}
                label="Status"
              >
                <MenuItem value="operational">Operational</MenuItem>
                <MenuItem value="maintenance">Maintenance</MenuItem>
                <MenuItem value="offline">Offline</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>External Site</InputLabel>
              <Select
                name="externalSite"
                value={formData.externalSite.toString()}
                onChange={handleExternalSiteChange}
                label="External Site"
              >
                <MenuItem value="false">No</MenuItem>
                <MenuItem value="true">Yes</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="tags"
              label="Tags (comma separated)"
              value={formData.tempTagsString || formData.tags.join(',')}
              onChange={handleTagsChange}
              fullWidth
              helperText="Enter tags separated by commas"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={onSubmit} 
          variant="contained" 
          disabled={!formData.name || !formData.description || !formData.url}
        >
          {submitText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WebsiteForm;
